import { Injectable } from '@angular/core';

//import { BetslipService } from 'packages/sports/web/app/src/betslip';

@Injectable()
export abstract class BetslipResultConfigurationBase {
    abstract canKeepPlacedBetsInBetslip(): boolean;
    abstract onKeepPlacedBetsInBetslip(value: boolean): void;
}

@Injectable()
export class BetslipResultConfiguration extends BetslipResultConfigurationBase {
    constructor(/*private betslipService: BetslipService*/) {
        super();
    }

    canKeepPlacedBetsInBetslip(): boolean {
        return true;
    }

    onKeepPlacedBetsInBetslip(value: boolean): void {
        //	this.betslipService.removePlacedPicksOnNewBetslip(!value);
    }
}

@Injectable()
export class EditBetResultConfiguration extends BetslipResultConfigurationBase {
    canKeepPlacedBetsInBetslip(): boolean {
        return false;
    }

    onKeepPlacedBetsInBetslip(value: boolean): void {}
}
